import { __assign } from "tslib";
import React, { useEffect, useState } from 'react';
import { withI18n } from 'panda-i18n';
import locale from '@/locales';
import { attachPropertiesToComponent } from '@/utils/attach-properties-to-component';
import { UICnDatePicker } from './date-picker';
import { renderToBody } from '@/components/cn-picker/render-to-body';
function prompt(props) {
    return new Promise(function (resolve) {
        var Wrapper = function () {
            var _a = useState(false), visible = _a[0], setVisible = _a[1];
            useEffect(function () {
                setVisible(true);
            }, []);
            return (React.createElement(CnDatePickerPro, __assign({}, props, { visible: visible, onConfirm: function (val) {
                    var _a;
                    (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, val);
                    resolve(val);
                }, onClose: function () {
                    var _a;
                    (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                    setVisible(false);
                    resolve(null);
                }, afterClose: function () {
                    var _a;
                    (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
                    unmount();
                } })));
        };
        var unmount = renderToBody(React.createElement(Wrapper, null));
    });
}
UICnDatePicker.displayName = 'CnDatePickerPro';
var CnDatePicker = withI18n(UICnDatePicker, { locale: locale });
var CnDatePickerPro = attachPropertiesToComponent(CnDatePicker, {
    prompt: prompt,
});
CnDatePickerPro.displayName = 'CnDatePickerPro';
export { CnDatePickerPro, CnDatePickerPro as CnDatePicker };
